import axios from "axios";

let localBaseUrl = "http://127.0.0.1:8000/api/";

export default {
  async baseUrl() {
    return localBaseUrl;
  },

  async getURLData(appUrl) {
    return await axios.get(appUrl);
  },

  async get(appUrl) {
    return await axios.get(appUrl);
  },

  async getWithHeader(appUrl) {
    let token = await localStorage.getItem("TOKEN_BEARER");
    return await axios.get(appUrl, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
  },

  async getUrl(url) {
    return await axios.get(url);
  },

  async postUrl(url, data) {
    return await axios.post(url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  async post(appUrl, data) {
    let token = await localStorage.getItem("TOKEN_BEARER");
    if (token) {
      return this.postWithHeader(appUrl, data);
    }

    return await axios.post(appUrl, data);
  },

  async postFormData(appUrl, data = {}) {
    let token = await localStorage.getItem("TOKEN_BEARER");
    if (token)
      return await axios.post(appUrl, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

    return await axios.post(appUrl, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async postWithHeader(appUrl, data = {}) {
    let token = await localStorage.getItem("TOKEN_BEARER");
    return await axios.post(appUrl, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
  },

  async postForm(appUrl, data) {
    return await axios.postForm(appUrl, data);
  },

  async setLocalVariable(key, value) {
    return await localStorage.setItem(key, value);
  },

  async postData(appUrl, data, method = "POST") {
    let token = await localStorage.getItem("TOKEN_BEARER");
    let headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };
    }

    // Default options are marked with *
    const response = await fetch(appUrl, {
      method: method, // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: headers,
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    }).catch(function(error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("USER");
        localStorage.removeItem("TOKEN_BEARER");
      } else {
        alert("Error");
        console.log(error);
      }
    });

    return response.json(); // parses JSON response into native JavaScript objects
  },

  async signOut() {
    localStorage.removeItem("USER");
    localStorage.removeItem("TOKEN_BEARER");
    window.location.reload();
  },

  errorHandler: function(error) {
    if (error.response && error.response.status === 401) {
      alert(`Votre session a expiré. Veuillez vous reconnecter`);

      this.signOut();
    } else if (error.response && error.response.status === 500) {
      alert(`Erreur lors traitement du requete`);
    } else {
      // alert(error.response.statusText);
    }
  },

  formatCourseCategories: function(categories, options) {
    let arrayCats =
      typeof categories === "string" ? JSON.parse(categories) : categories;
    let position = arrayCats.length - 1;
    let feedback = "";

    arrayCats.forEach((arrayCat, key) => {
      let checkExistence = options.filter((option) => {
        return parseInt(option.id) === parseInt(arrayCat);
      });

      if (checkExistence.length > 0) {
        if (key === position) {
          feedback += checkExistence[0].name;
        } else {
          feedback += checkExistence[0].name + " | ";
        }
      }
    });

    return feedback;
  },
};
